import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { createForgotSchema } from "./Forgot-schema";
import Classnames from 'classnames';
import Form from "./form";
import { emailTokenResetPass, resetLoginErrors } from "../Auth.ducks";
import { withTranslation } from 'react-i18next';

import srcIconLogo from "../../../styles/img/logo-kiuono-white.svg";
import { Redirect } from "react-router-dom";
const LogoLogin = () => <object data={srcIconLogo} type="image/svg+xml" className="img-fluid logo-login" />

class ForgotPassword extends Component {
  static propTypes = {
    emailTokenResetPass: PropTypes.func,
    auth: PropTypes.object,
  };


  handleForgot = values => {
    let data = {
      "identifiant": values.identifiant
    }
    this.props.emailTokenResetPass(localStorage.getItem('token'), data);
  };

  render() {
    const { t } = this.props;
     const {
      resetLoginErrors,
      auth: { isRedirectPassword,error }
    } = this.props;
    return (
      <div className="main-wrapper login-page">
        <div className="container-login">
          <div className="entete-login">
            <LogoLogin />
            <h1>{t('login.tagline')}</h1>
          </div>
          <Formik
            initialValues={{ identifiant: "" }}
            validationSchema={createForgotSchema(t)}
            onSubmit={(values, actions) => this.handleForgot(values)}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              setFieldValue,
              errors,
              touched
            }) => {
              return (
                <form onSubmit={handleSubmit} className="box-login">
                  <div >
                    <h2 className="mb-4">{t('forgot_password.title')}</h2>
                    <div className={Classnames("form-group", { "error-mess": errors.identifiant && touched.identifiant || error })}>
                      <input type="text" name="identifiant"
                        onChange={(event) => { handleChange(event); resetLoginErrors(); }}
                        value={values.identifiant} className="form-control" id="ipt-identifiant" placeholder={t('forgot_password.placeholder')} />
                      {errors.identifiant && touched.identifiant ? (
                        <p >{errors.identifiant}</p>
                      ) : null}
                      {error ? (
                        <p >{error}</p>
                      ) : null}
                    </div>
                  </div>
                  <button type="submit"
                    onClick={handleSubmit} className="btn-gradient mt-4">{t('forgot_password.submit')}</button>

                </form>
              );
            }}
          </Formik>
          {isRedirectPassword ? <Redirect to="/message" /> : ""}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = { emailTokenResetPass, resetLoginErrors };

const withStore = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withTranslation()(withStore(ForgotPassword));
